import { Box, Button, Modal, Stack, Text, Title } from "@mantine/core";
import { IconAlertTriangle, IconRefresh } from "@tabler/icons-react";

type QuickRecordUploadFailedModalProps = {
  modalOpened: boolean;
  onCancel: () => void;
  onTryAgain: () => void;
};

const QuickRecordUploadFailedModal = (
  props: QuickRecordUploadFailedModalProps,
) => {
  const { modalOpened, onCancel, onTryAgain } = props;

  return (
    <Modal
      opened={modalOpened}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
      title={""}
      onClose={() => {}}
    >
      <Box pl={50} pr={50} pb={50}>
        <Stack align="center" gap={30} mb={30}>
          <IconAlertTriangle size={120} color={"orange"} />
          <Title fw={600} fz={24}>
            Failed to upload
          </Title>
          <Text fw={500} fz={16} ta={"center"}>
            Your recording failed to upload. Please try again. If the problem
            persists, please try again later in the patient case details. Your
            recording is still saved locally.
          </Text>
        </Stack>
        <Stack mt="md">
          <Button
            variant="outline"
            h={50}
            w={"100%"}
            radius={50}
            onClick={() => {
              onCancel();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            h={50}
            w={"100%"}
            radius={50}
            leftSection={<IconRefresh size={16} />}
            onClick={() => {
              onTryAgain();
            }}
          >
            Try again
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default QuickRecordUploadFailedModal;
